import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, ArrowRight, MessageCircle } from "lucide-react";
import { SKOOL_URL, SALES_CLOSE_AT } from "@/lib/salesClosed";

// Slim mobile-only sticky bar at the bottom of the viewport, showing a live
// countdown and a direct "Reserve Now" CTA. Hidden on md+ where the top bar
// already provides constant urgency.

function computeCountdown(now) {
  const diff = Math.max(0, SALES_CLOSE_AT - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  return { d, h, m, done: diff === 0 };
}

export default function MobileStickyCta({ tier = "day-pass" }) {
  const [t, setT] = useState(() => computeCountdown(Date.now()));
  useEffect(() => {
    const id = setInterval(() => setT(computeCountdown(Date.now())), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="md:hidden fixed inset-x-0 bottom-0 z-[55] bg-[#0A1128] border-t border-[#FACC15]/40 shadow-[0_-8px_20px_rgba(0,0,0,0.35)] px-3 py-2 flex items-center gap-2"
      data-testid="mobile-sticky-cta"
    >
      <div className="flex-1 min-w-0">
        <div className="text-[9px] font-black uppercase tracking-widest text-red-400">
          {t.done ? "Sales Closed" : "Sales close in"}
        </div>
        {t.done ? (
          <div className="text-[12px] font-bold text-white leading-tight">
            Message Coach Jacob on Skool
          </div>
        ) : (
          <div className="text-[13px] font-black text-white tabular-nums">
            {t.d}<span className="text-white/60">d</span> · {String(t.h).padStart(2, "0")}<span className="text-white/60">h</span> · {String(t.m).padStart(2, "0")}<span className="text-white/60">m</span>
          </div>
        )}
      </div>
      {t.done ? (
        <a
          href={SKOOL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-sticky-skool"
          className="inline-flex items-center gap-1.5 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A1128] font-black uppercase tracking-wider text-xs px-4 py-3 rounded-lg transition-colors shrink-0"
        >
          <MessageCircle size={14} /> Message Jacob
          <ArrowRight size={13} />
        </a>
      ) : (
        <Link
          to={`/register?tier=${tier}`}
          data-testid="mobile-sticky-reserve"
          className="inline-flex items-center gap-1.5 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A1128] font-black uppercase tracking-wider text-xs px-4 py-3 rounded-lg transition-colors shrink-0"
        >
          <Ticket size={14} /> Reserve
          <ArrowRight size={13} />
        </Link>
      )}
    </div>
  );
}
